import { Injectable } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { MessageService } from 'primeng/api';
import { BackendService } from '../core/backend.service';
import { CONFIG } from '../core/config';
import { ApiResult } from '../core/messages/api-result';
import { DisplayMessage } from '../core/messages/display-message';
import { Severity } from '../shared/enums/severity';

@Injectable({
  providedIn: 'root',
})
export class ReseedPermissionsService {

  constructor(
    private backendService: BackendService,
    private messageService: MessageService,
    private i18NextPipe: I18NextPipe,
  ) { }

  public reseedPermissions(): void {
    this.backendService.getBooleanResponseForObject(CONFIG.apiRoutes.reseedPermissions, null).subscribe(
      result => {
        this.messageService.add(new DisplayMessage(this.i18NextPipe.transform('ReseedPermission.PermissionReCalculationBegun'), this.i18NextPipe.transform('ReseedPermission.AReCalculationofUserPermissionsHasBegun'), Severity.Success));
      },
      (errorResult: ApiResult) => {
        if (errorResult) {
          errorResult.messages.forEach(message => this.messageService.add(new DisplayMessage('ReseedPermission', message.text, errorResult.severity)));
        }
      },
    );
  }
}
